const configProviderContextKey = Symbol();

export { configProviderContextKey };
//# sourceMappingURL=config-provider2.mjs.map
